const getCodeIntro = () => {
    return `
const FloatingTab = ({ data, onOpen, onClose }) => {
};

FloatingTab.propTypes = {
    data: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    onOpen: PropTypes.func,
    onClose: PropTypes.func
}
export default FloatingTab;
    `;
}

export default getCodeIntro;
